export enum SHIFTS {
  CREATE_SHIFTS = 'CREATE_SHIFTS',
  READ_SHIFTS = 'READ_SHIFTS',
  UPDATE_SHIFTS = 'UPDATE_SHIFTS',
  DELETE_SHIFTS = 'DELETE_SHIFTS',
}

export enum USERS {
  UPDATE_ROLE = 'UPDATE_ROLE',
}

export enum SHIFT {
  CREATE_SHIFT = 'CREATE_SHIFT',
  READ_SHIFT = 'READ_SHIFT',
  UPDATE_SHIFT = 'UPDATE_SHIFT',
  DELETE_SHIFT = 'DELETE_SHIFT',
}

export enum TIMESHEETS {
  CREATE_TIMESHEETS = 'CREATE_TIMESHEETS',
  READ_TIMESHEETS = 'READ_TIMESHEETS',
  UPDATE_TIMESHEETS = 'UPDATE_TIMESHEETS',
  DELETE_TIMESHEETS = 'DELETE_TIMESHEETS',
}

export enum REPORTS {
  CREATE_REPORTS = 'CREATE_REPORTS',
  READ_REPORTS = 'READ_REPORTS',
  UPDATE_REPORTS = 'UPDATE_REPORTS',
  DELETE_REPORTS = 'DELETE_REPORTS',
}

export enum STATEMENTS {
  READ_STATEMENTS = 'READ_STATEMENTS',
}

export enum TEMPLATES {
  CREATE_TEMPLATES = 'CREATE_TEMPLATES',
  READ_TEMPLATES = 'READ_TEMPLATES',
  UPDATE_TEMPLATES = 'UPDATE_TEMPLATES',
  DELETE_TEMPLATES = 'DELETE_TEMPLATES',
}

export enum PAYMENTS {
  CREATE_PAYMENTS = 'CREATE_PAYMENTS',
  READ_PAYMENTS = 'READ_PAYMENTS',
  UPDATE_PAYMENTS = 'UPDATE_PAYMENTS',
  DELETE_PAYMENTS = 'DELETE_PAYMENTS',
}

export enum PAYMENT {
  CREATE_PAYMENT = 'CREATE_PAYMENT',
  READ_PAYMENT = 'READ_PAYMENT',
  UPDATE_PAYMENT = 'UPDATE_PAYMENT',
  DELETE_PAYMENT = 'DELETE_PAYMENT',
}

export enum UPSHIFTER {
  CREATE_UPSHIFTER = 'CREATE_UPSHIFTER',
  READ_UPSHIFTER = 'READ_UPSHIFTER',
  UPDATE_UPSHIFTER = 'UPDATE_UPSHIFTER',
  DELETE_UPSHIFTER = 'DELETE_UPSHIFTER',
}

export enum LOCATION {
  CREATE_LOCATION = 'CREATE_LOCATION',
  READ_LOCATION = 'READ_LOCATION',
  UPDATE_LOCATION = 'UPDATE_LOCATION',
  DELETE_LOCATION = 'DELETE_LOCATION',
}

export enum NOTIFICATIONS {
  READ_NOTIFICATIONS = 'READ_NOTIFICATIONS',
}

export enum BUSINESS_UI_RELATED {
  CAN_UPDATE_SITE_MANAGERS = 'CAN_UPDATE_SITE_MANAGERS',
  CAN_UPDATE_MANAGERS = 'CAN_UPDATE_MANAGERS',
  CAN_READ_COMPANY_NAME = 'CAN_READ_COMPANY_NAME',
}

export enum UPSHIFTER_UI_RELATED {
  CAN_UPDATE_SITE_MANAGERS = 'CAN_UPDATE_SITE_MANAGERS',
  CAN_UPDATE_MANAGERS = 'CAN_UPDATE_MANAGERS',
  CAN_READ_COMPANY_NAME = 'CAN_READ_COMPANY_NAME',
}

export enum APPLICANTS {
  DOWNLOAD_APPLICANTS = 'DOWNLOAD_APPLICANTS',
}

export enum INVOICES {
  CREATE_INVOICE = 'CREATE_INVOICE',
  READ_INVOICE = 'READ_INVOICE',
  UPDATE_INVOICE = 'UPDATE_INVOICE',
  DELETE_INVOICE = 'DELETE_INVOICE',
  PAY_INVOICE = 'PAY_INVOICE',
}

export enum HIDE_UNHIDE_APPLICANTS {
  UPDATE_HIDE_UNHIDE_APPLICANTS = 'UPDATE_HIDE_UNHIDE_APPLICANTS',
}
